<template>
  <div>
    <div class="lg:mt-10 md:mt-9 mt-5 lg:flex md:flex gap-2">
      <div class="container">
        <h2 class="fsize32 sm-fsize24 font-bold text4F0A4B">
          Planning for Future
        </h2>
        <p class="fsize16 sm-fsize14">
          Caregivers may want to know about legal and financial planning
          considerations when caring for someone with dementia, such as creating
          a will, arranging for long-term care, and obtaining power of attorney
          Caring for someone with dementia can be a challenging and emotional
          experience. As a caregiver, it is essential to plan for the future to
          ensure that your loved one's legal and financial affairs are in order.
          Planning ahead can help reduce stress and uncertainty and provide
          peace of mind for both the caregiver and the individual with dementia.
        </p>
        <div class="lg:mt-8 md:mt-6 my-5">
          <h2 class="fsize24 sm-fsize16 text4F0A4B mb-4">
            <span class="font-bold"
              >Legal and Financial planning considerations </span
            >that caregivers may want to consider:
          </h2>
          <div
            class="w-full grid grid-cols-2 items-center p-3 gap-5 text-center"
          >
            <div class="w-full lg:mt-0 md:mt-0 mt-4 finance-card">
              <p class="fsize16 text4F0A4B">
                <span class="font-bold">Create a Will:</span> Creating a will is
                essential for individuals with dementia to ensure that their
                wishes are carried out after their passing. A will specifies how
                assets should be distributed and who should manage the estate.
                It is important to create a will while the individual with
                dementia is still able to make decisions and understand the
                consequences of their choices.
              </p>
            </div>
            <div class="w-full lg:mt-0 md:mt-0 mt-4 finance-card">
              <p class="fsize16 text4F0A4B">
                <span class="font-bold">Obtain Power of Attorney:</span> Power
                of attorney is a legal document that grants someone the
                authority to make decisions on behalf of the individual with
                dementia. There are different types of power of attorney,
                including financial power of attorney and medical power of
                attorney. It is important to obtain power of attorney while the
                individual with dementia is still able to make decisions.
              </p>
            </div>
            <div class="w-full lg:mt-0 md:mt-0 mt-4 finance-card">
              <p class="fsize16 text4F0A4B">
                <span class="font-bold">Arrange for Long-Term Care:</span>
                Individuals with dementia may require long-term care, such as a
                nursing home or assisted living facility. It is essential to
                plan for long-term care in advance to ensure that the
                individual's needs are met and that their finances are
                protected. Medicaid is a government program that may help cover
                the cost of long-term care for individuals with limited
                financial resources.
              </p>
            </div>
            <div class="w-full lg:mt-0 md:mt-0 mt-4 finance-card">
              <p class="fsize16 text4F0A4B">
                <span class="font-bold">Consider Guardianship:</span>
                Guardianship is a legal arrangement where a court appoints
                someone to make decisions on behalf of an individual who is
                unable to make decisions for themselves. Guardianship may be
                necessary if the individual with dementia does not have power of
                attorney and is unable to make decisions.
              </p>
            </div>
            <div class="w-full lg:mt-0 md:mt-0 mt-4 finance-card">
              <p class="fsize16 text4F0A4B">
                <span class="font-bold">Review Insurance Policies:</span>
                Reviewing insurance policies, such as life insurance and
                long-term care insurance, can help ensure that the individual's
                financial needs are met. It is important to review insurance
                policies regularly and make changes as needed to reflect
                changing circumstances.
              </p>
            </div>
          </div>
        </div>
        <p class="fsize16 text-dark mt-6">
          In conclusion, planning for the future is an essential part of caring
          for someone with dementia. Legal and financial planning
          considerations, such as creating a will, obtaining power of attorney,
          arranging for long-term care, considering guardianship, and reviewing
          insurance policies, can help ensure that the individual's needs are
          met and that their wishes are carried out. Caregivers should seek the
          advice of an attorney or financial advisor to ensure that all legal
          and financial matters are properly addressed. Planning ahead can
          provide peace of mind and help caregivers focus on providing the best
          possible care for their loved one with dementia.
        </p>
        <!-- </div> -->
        <!-- <div class="border-left lg:w-2/12 md:w-2/12 w-full lg:mt-0 md:mt-0 mt-4">
        <SideBlogs />
      </div> -->
        <div class="lg:mt-10 md:mt-9 my-5 text-center">
          <h2 class="fsize24 sm-fsize16 text4F0A4B mb-4">
            What is long term memory? | What is long term memory loss? | How do
            you prevent this from happening?
          </h2>
          <p class="fsize16 sm-fsize14">
            Long-term memory refers to the storage and retrieval of information
            that occurred more than a few minutes ago, ranging from several
            hours to many years ago. Long-term memory can be divided into two
            main categories: explicit (declarative) memory and implicit
            (procedural) memory.
          </p>
        </div>
        <div class="w-full items-center grid grid-cols-2 gap-8">
          <div class="w-full flex lg:mt-0 md:mt-0 mt-4 items-center">
            <div class="lg:w-8/12 md:w-8/12 w-full px-4">
              <h2 class="fsize16 my-2 font-bold text4F0A4B justify-self-end">
                Explicit Memory
              </h2>
              <p class="fsize14 text-right">
                It involves the conscious recollection of information, such as
                facts, events, and experiences. This type of memory can be
                further divided into semantic memory (memory for general
                knowledge and facts) and episodic memory (memory for specific
                events and experiences).
              </p>
            </div>
            <div class="lg:w-4/12 md:w-4/12 w-full">
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20Dementia%20Page/Explicit%20Memory.jpg"
                alt="dementia-concern"
                class="planning-img object-cover"
              />
            </div>
          </div>
          <div class="w-full flex lg:mt-0 md:mt-0 mt-4 items-center">
            <div class="lg:w-4/12 md:w-4/12 w-full">
              <img
                src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Images%20for%20Dementia%20Page/Implicit%20Memory.jpg"
                alt="dementia-concern"
                class="planning-img1 object-cover"
              />
            </div>
            <div class="lg:w-8/12 md:w-8/12 w-full px-4">
              <h2 class="fsize16 my-2 font-bold text4F0A4B">Implicit Memory</h2>
              <p class="fsize14">
                on the other hand, is the unconscious retention of information,
                such as skills, habits, and conditioned responses. Examples of
                implicit memory include riding a bicycle, typing on a keyboard,
                and tying shoelaces.
              </p>
            </div>
          </div>
        </div>
        <div>
          <p class="fsize16 sm-fsize14 mt-8">
            <span class="fsize24 sm-fsize20 font-bold">Long-term memory</span>
            loss refers to the inability to recall information that was
            previously stored in long-term memory. This type of memory loss can
            be caused by a variety of factors, including aging, brain injury,
            illness, and certain medications. Some common examples of long-term
            memory loss include forgetting important events or dates, difficulty
            remembering names or faces, and trouble recalling previously learned
            information. <br />
            Preventing long-term memory loss can be challenging, but there are
            several strategies that may help. Some tips for maintaining and
            improving long-term memory include:
          </p>
          <div class="w-full lg:mt-0 md:mt-0 mt-4">
            <ul class="list-decimal">
              <li class="fsize16 pb-2">
                Staying physically active: Regular exercise has been shown to
                improve brain function and promote the growth of new brain
                cells.
              </li>
              <li class="fsize16 pb-2">
                Eating a healthy diet: A balanced diet that is rich in fruits,
                vegetables, and whole grains can help support brain health.
              </li>
              <li class="fsize16 pb-2">
                Getting enough sleep: Sleep plays a critical role in
                consolidating memories, so it is important to get enough rest
                each night.
              </li>
              <li class="fsize16 pb-2">
                Managing stress: Chronic stress can have a negative impact on
                memory and cognitive function, so it is important to find ways
                to manage stress, such as through meditation or yoga.
              </li>
              <li class="fsize16 pb-2">
                Engaging in cognitive activities: Activities that challenge the
                brain, such as reading, playing games, and learning new skills,
                can help maintain and improve long-term memory.
              </li>
              <li class="fsize16 pb-2">
                Seeking medical attention: If you are experiencing memory loss
                or other cognitive symptoms, it is important to seek medical
                attention to determine the underlying cause and receive
                appropriate treatment.
              </li>
            </ul>
          </div>
          <p class="fsize16 text-dark mt-6">
            In conclusion, long-term memory refers to the storage and retrieval
            of information that occurred more than a few minutes ago. Long-term
            memory loss is the inability to recall information that was
            previously stored in long-term memory. While preventing long-term
            memory loss can be challenging, there are several strategies that
            may help, including staying physically active, eating a healthy
            diet, getting enough sleep, managing stress, engaging in cognitive
            activities, and seeking medical attention if necessary.
          </p>
        </div>
        <div>
          <p class="fsize16 sm-fsize14 mt-8">
            <span class="fsize24 sm-fsize20 font-bold">Short-term memory</span>
            is the temporary storage of information that lasts for only a few
            seconds to a minute. It is the part of the memory system that allows
            us to hold onto and manipulate information in our minds while we are
            performing mental tasks such as reading, speaking, or
            problem-solving. <br />
            is the temporary storage of information that lasts for only a few
            seconds to a minute. It is the part of the memory system that allows
            us to hold onto and manipulate information in our minds while we are
            performing mental tasks such as reading, speaking, or
            problem-solving.
            <br />
            In certain eventuality, short-term memory can be more severely
            impacted. For example, traumatic brain injury or stroke can damage
            the areas of the brain responsible for short-term memory, making it
            difficult to remember new information or retain it for more than a
            few seconds.
          </p>
        </div>
        <p class="fsize16 text-dark mt-8">
          Overall, while short-term memory can be impacted in various ways, it
          is a normal and essential aspect of the memory system that allows us
          to function in our daily lives. If you are experiencing difficulty
          with short-term memory, it may be helpful to identify potential
          underlying causes, such as stress or sleep deprivation, and address
          them appropriately. If the problem persists or worsens, it is
          important to consult a healthcare professional to determine the
          underlying cause and receive appropriate treatment.
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import SideBlogs from "./components/SideBlogs.vue";
export default {
  components: {
    SideBlogs,
  },
};
</script>
<style>
.finance-card {
  background-color: #cceff2;
  color: white;
  height: 240px;
  align-content: center;
  border-radius: 8px;
  padding: 16px;
}
.planning-img {
  height: 190px;
  width: 100%;
  border-radius: 75px 0 75px 75px;
}
.planning-img1 {
  height: 190px;
  width: 100%;
  border-radius: 0 75px 75px 75px;
}

.list-dec {
  list-style: decimal;
}
</style>
